// src/components/PasswordProtection.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const PasswordContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f8f4ec 0%, #e8dfd0 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 160 160'%3E%3Cg fill='%23b38b6d' fill-opacity='0.1'%3E%3Cpath d='M80 20c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6zm20 0c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6z'/%3E%3C/g%3E%3C/svg%3E");
`;

const PasswordBox = styled.div`
  background-color: rgba(255, 255, 255, 0.95);
  padding: 30px 40px 40px;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 90%;
  text-align: center;
  border: 1px solid rgba(179, 139, 109, 0.2);
  position: relative;
  overflow: hidden;
`;

const Title = styled.h2`
  color: #947060;
  font-family: 'Cormorant Garamond', serif;
  font-size: 2rem;
  margin-bottom: 20px;
  position: relative;
  font-weight: 400;
  
  &::after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(179, 139, 109, 0.4), transparent);
    width: 180px;
  }
`;

const NameSpan = styled.span`
  display: block;
  font-family: 'Great Vibes', cursive;
  font-size: 2rem;
  letter-spacing: 1px;
  font-style: normal;
  margin-top: 5px;
  color: #b38b6d;
`;

const Form = styled.form`
  margin-top: 30px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #e0d5c5;
  border-radius: 4px;
  font-size: 16px;
  background-color: rgba(255, 255, 255, 0.8);
  color: #5a4a42;
  font-family: 'Cormorant Garamond', serif;
  transition: all 0.3s ease;
  box-sizing: border-box;
  text-align: center;
  letter-spacing: 2px;
  margin-bottom: 20px;
  
  &:focus {
    outline: none;
    border-color: #b38b6d;
    box-shadow: 0 0 0 3px rgba(179, 139, 109, 0.2);
    background-color: white;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 14px;
  background: linear-gradient(to right, #b38b6d, #d4b59e);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(179, 139, 109, 0.3);
  font-family: 'Cormorant Garamond', serif;
  letter-spacing: 1px;
  margin-top: 10px;
  
  &:hover {
    background: linear-gradient(to right, #a07a5f, #c4a58e);
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(179, 139, 109, 0.4);
  }
`;

const HintText = styled.p`
  color: #947060;
  font-style: italic;
  margin-top: 20px;
  font-size: 0.95rem;
`;

const ErrorMessage = styled.p`
  color: #d36262;
  margin-top: 15px;
  font-size: 0.95rem;
`;

const PasswordProtection = ({ onCorrectPassword }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [attempts, setAttempts] = useState(0);
  
  // Check if already authenticated
  useEffect(() => {
    const isAuthenticated = localStorage.getItem('wedding_site_authenticated');
    if (isAuthenticated === 'true') {
      onCorrectPassword();
    }
  }, [onCorrectPassword]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === '10252025') {
      // Store authentication in localStorage
      localStorage.setItem('wedding_site_authenticated', 'true');
      onCorrectPassword();
    } else {
      setAttempts(attempts + 1);
      setError('The password is incorrect. Please try again.');
      setPassword('');
    }
  };
  
  return (
    <PasswordContainer>
      <PasswordBox>
        <Title>
          Welcome to Our Wedding Website
          <NameSpan>Erika & Andrew</NameSpan>
        </Title>
        
        <Form onSubmit={handleSubmit}>
          <Input
            type="text"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            maxLength={8}
            autoComplete="off"
          />
          
          <Button type="submit">Enter</Button>
        </Form>
        
        {error && <ErrorMessage>{error}</ErrorMessage>}
        
        <HintText>
          Hint: What's the wedding date? Enter in "mmddyyyy" format.
        </HintText>
      </PasswordBox>
    </PasswordContainer>
  );
};

export default PasswordProtection;